import { Col, Form, Row } from 'antd';
import { observer } from 'mobx-react';
import InputComponent from '../../../../component/InputComponent';
import { publicSettingRequest } from '../../../../request/AuthRequest';

const FormComponent = observer((props) => {
	const { handleChange, onFinish, id, form } = props;

	return (
		<Form
			id={id}
			layout="vertical"
			form={form}
			onFinish={onFinish}
			autoComplete="off"
			onChange={handleChange}
		>
			<Row gutter={24}>
				<Col span={12}>
					<InputComponent
						required
						name="settingKey"
						label="Setting Key"
						placeholder="Enter Setting Key"
						rules={publicSettingRequest.settingKey}
						disabled={id === 'EditForm' ? true : false}
					/>
				</Col>
				<Col span={12}>
					<InputComponent
						required
						name="settingName"
						label="Setting Name"
						placeholder="Enter Setting Name"
						rules={publicSettingRequest.settingName}
					/>
				</Col>
				<Col span={12}>
					<InputComponent
						required
						type={'textarea'}
						name="settingValue"
						label="Setting Value"
						placeholder="Enter Setting Value"
						rules={publicSettingRequest.settingValue}
					/>
				</Col>
				<Col span={12}>
					<InputComponent
						name="settingdbType"
						label="Setting DB Type"
						placeholder="Enter Setting DB Type"
						rules={publicSettingRequest.settingdbType}
					/>
				</Col>
			</Row>
		</Form>
	);
});

export default FormComponent;
